const initState = () => {
  return {
    newPaths: {},
    newForm: {},
    typeDrawing: ''
  };
};

const drawMap = {
  state: {
    newPaths: initState().newPaths,
    typeDrawing: initState().typeDrawing,
    newForm: initState().newForm
  },

  getters: {
    newPaths: state => state.newPaths,
    typeDrawing: state => state.typeDrawing,
    newForm: state => state.newForm
  },

  mutations: {
    SET_NEW_PATHS (state, payload) {
      state.newPaths = payload;
    },
    SET_TYPE_DRAWING (state, payload) {
      state.typeDrawing = payload;
    },
    SET_NEW_FORM (state, payload) {
      state.newForm = payload;
    }
  },

  actions: {
    SET_NEW_PATHS ({ commit, dispatch }, payload) {
      commit('SET_NEW_PATHS', payload);
    },
    SET_TYPE_DRAWING ({ commit, dispatch }, payload) {
      commit('SET_TYPE_DRAWING', payload);
    },
    SET_NEW_FORM ({ commit, dispatch }, payload) {
      commit('SET_NEW_FORM', payload);
    }
  }
};

export default drawMap;



// WEBPACK FOOTER //
// ./src/store/modules/drawMap.js